import { useMediaQuery } from './useMediaQuery';

/** Below the sm breakpoint (640px): where pages swap their toolbar for a PhonePanel. */
export function useIsPhone() {
  return useMediaQuery('(max-width: 639.98px)');
}
